import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/** Los días en que abre el bar. Las dos funciones que escriben son del administrador. Adjudicación 312. */
export const rutaDiasApertura = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/dias-apertura',
  component: lazyRouteComponent(() => import('./dias-apertura-pantalla.js'), 'RutaDiasApertura'),
});
